
import AllProducts from './AllProducts';
// import ProductCard from './ProductCard';
export default function JewelleryCatalogue() {
  return (
    <div>

        {/* <ProductCard/> */}
      <AllProducts/>
    </div>
  )
}
